import { tv } from "@utils/tw"
import single from "@views/single"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Logos",
  description: "One or more inline logos",
  icon: "star-filled",
  tags: ["#subpage"],
  flags: {
    contentWidth: true,
  },
  blockStyles: [
    {
      label: "Small",
      name: "sm",
      isDefault: true,
    },
    {
      label: "Medium",
      name: "md",
    },
    {
      label: "Large",
      name: "lg",
    },
  ],
}

export default defineBlock("content/logos", (props) => {
  return (
    <div>
      <div className={env.admin ? "" : layout({ size: props.blockStyle })}>
        <InnerBlocks
          orientation="horizontal"
          defaultBlocks={[["content/logo-item", {}]]}
          allowedBlocks={["content/logo-item"]}
          adminClassName={layout({ size: props.blockStyle })}
          appender={{ type: "simple" }}
        />
      </div>
    </div>
  )
})

const layout = tv({
  base: "flex flex-wrap items-center gap-3 [&_.logo-item]:w-[--logoSize]",
  variants: {
    size: {
      sm: "[--logoSize:90px]",
      md: "[--logoSize:140px]",
      lg: "[--logoSize:180px]",
    },
  },
  defaultVariants: {
    size: "sm",
  },
})
